// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Vision UI Dashboard PRO React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

export function AppBreadcrumbs({ icon, title, breadcrumb, route, light, handleMiniSidenav, miniSidenav }) {
  const routes = route.slice(0, -1);

  return (
    <VuiBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <Icon fontSize="small" sx={{
          display: "block",
        }} onClick={handleMiniSidenav}>
          {miniSidenav ? "menu_open" : "menu"}
        </Icon>
        <Link to="/dashboard">
          <VuiTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </VuiTypography>
        </Link>
        {routes.map((el) => (
          <Link to={`/${el}`} key={el}>
            <VuiTypography
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {el}
            </VuiTypography>
          </Link>
        ))}
        <VuiTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color={light ? "white" : "dark"}
          sx={{
            lineHeight: 0,
          }}
        >
          {breadcrumb}
        </VuiTypography>
      </MuiBreadcrumbs>
      <VuiTypography
        fontWeight="bold"
        variant="h3"
        noWrap
        color="white"
        sx={({ breakpoints }) => ({
          letterSpacing: "1px",
          marginTop: "15px",
          whiteSpace: "wrap",
          [breakpoints.down("md")]: {
            fontSize: "1rem",
            marginTop: "10px",
          },
          [breakpoints.only("md")]: {
            fontSize: "1.5rem",
          },
        })}
      >
        {title}
      </VuiTypography>
    </VuiBox>
  );
}

// Setting default values for the props of Breadcrumbs
AppBreadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the AppBreadcrumbs
AppBreadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};
